import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { feeGroup, feesTypes, paymentType } from '../../../core/common/selectoption/selectoption'
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import {
  MaritalStatus,
  allSex,
} from "../../../../core/common/selectoption/selectoption";
import { TagsInput } from "react-tag-input-component";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { useLocation } from "react-router-dom";
import { _get, _post } from "../../../Utils/Helper";
import { SingleValue } from "react-select";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
// import { Table } from "react-bootstrap";

const TeacherForm = () => {
  const _form = {
    name: "",
    last_name: "",
    sex: "",
    age: "",
    address: "",
    date_of_birth: "",
    marital_status: "",
    state_of_origin: "",
    mobile_number: "",
    email_address: "",
    qualification: "",
    working_experience: "",
    religion: "",
    last_place_of_work: "",
    do_you_have: "",
    when_do: "",
    account_name: "",
    account_number: "",
    bank: "",
    class_name: "",
    subject: "",
    school_location: "",
    section: "",
    branch_id: "",
    password: "",
  };

  interface SubjectClass {
    teacher_id: number;
    class_name: string;
    subject: string;
    section: string;
    class_code: number;
    branch_id: string;
  }
  interface TeacherRole {
    teacher_id: number;
    section: string;
    class_name: string;
    role: string;
    class_code: number;
    branch_id: string;
  }
  const _teacherClass = {
    teacher_id: 0,
    subject: "",
    class_name: "",
    section: "",
    class_code: 0,
    branch_id: "",
  };
  const _teacherRole = {
    teacher_id: 0,
    section: "",
    class_name: "",
    role: "",
    class_code: 0,
    branch_id: "",
  };

  const roleOptions = [
    { label: "Form Master", value: "form_master" },
    { label: "Assistant Form Master", value: "assistant_form_master" },
  ];
  const [form, setForm] = useState(_form);
  const [teacherClasses, setTeacherClasses] = useState<SubjectClass[]>([]);
  const [teacherClass, setTeacherClass] = useState<SubjectClass>(_teacherClass);
  const [teacherRoles, setTeacherRoles] = useState<TeacherRole[]>([]);
  const [teacherRole, setTeacherRole] = useState<TeacherRole>(_teacherRole);
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const navigate = useNavigate();

  const { user, selected_branch } = useSelector((state: RootState) => state.auth);
  const handleSubmit = () => {
    let arr = teacherClasses;
    if (
      teacherClass.class_name &&
      teacherClass.section &&
      teacherClass.subject
    ) {
      const class_code = classes.find(
        (cls) => cls.class_name === teacherClass.class_name
      )?.class_code;
      const branch_id = selected_branch.branch_id;

      arr.push({ ...teacherClass, class_code, branch_id });
    }

    let rolesArr = teacherRoles;
    if (teacherRole.class_name && teacherRole.section && teacherRole.role) {
      const class_code = classes.find(
        (cls) => cls.class_name === teacherRole.class_name
      )?.class_code;
      const branch_id = selected_branch.branch_id;

      rolesArr.push({ ...teacherRole, class_code, branch_id });
      setTeacherClass(_teacherClass);
    }

    _post(
      "teachers",
      {
        ...form,
        query_type: "create",
        teacherSubjects: arr,
        teacherRoles: rolesArr,
        school_id: user.school_id,
        branch_id: selected_branch.branch_id,
     },
      (res) => {
        if (res.success) {
          toast.success("Submitted successfully");
          console.log(form);
          setForm(_form);
          navigate(-1);
        }
      },
      (err) => {
        // setLoading(false);
        console.log(err);
      }
    );

    // e.preventDefault();
    // if (validate()) {
    //     // Form is valid, handle submission
    //     console.log(form);
    //     setForm(_form);
    //     setErrors({});
    // }
  };

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const { subjects, classes, sections } = useSelector((state: RootState) => state.auth);

  const handleAddRole = () => {
    const class_code = classes.find(
      (cls) => cls.class_name === teacherRole.class_name
    )?.level;

    setTeacherRoles((prev) => [
      ...prev,
      {
        ...teacherRole,
        class_code,
      },
    ]);
    setTeacherRole(_teacherRole);
  };

  // Extract unique sections
  // const sections = classes.length
  //   ? Array.from(new Set(classes.map((cls) => cls.section)))
  //   : [];

  const sectionSubjects = teacherClass.class_code
    ? subjects.filter((cls) => cls.class_code === teacherClass.class_code)
    : subjects;

  const mapped_section = sections?.map((i: any) => ({
    label: i.section_name,
    value: i.section_name,
  }));

  const sectionClasses = teacherClass.section
    ? classes.filter((cls) => cls.section === teacherClass.section)
    : classes;

  const classOptions = sectionClasses?.map((i: any) => ({
    label: i.class_name,
    value: i.class_name,
    class_code: i.class_code,
  }));

  const handleAdd = () => {
    const class_code = classes.find(
      (cls) => cls.class_name === teacherClass.class_name
    )?.level;

    setTeacherClasses((prev) => [
      ...prev,
      {
        ...teacherClass,
        class_code,
      },
    ]);
    // handleParent();
    setTeacherClass(_teacherClass);
  };

  const subjectOptions = sectionSubjects?.map((i: any) => ({
    label: i.subject,
    value: i.subject,
  }));
  const routes = all_routes;

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [defaultDate, setDefaultDate] = useState<dayjs.Dayjs | null>(null);
  // const [newContents, setNewContents] = useState<number[]>([0]);
  const location = useLocation();
  // const addNewContent = () => {
  //   setNewContents([...newContents, newContents.length]);
  // };
  // const removeContent = (index: any) => {
  //   setNewContents(newContents.filter((_, i) => i !== index));
  // };
  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  useEffect(() => {
    if (location.pathname === routes.editTeacher) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${month}-${day}-${year}`;
      const defaultValue = dayjs(formattedDate);
      setIsEdit(true);
      setDefaultDate(defaultValue);
      console.log(formattedDate, 11);
    } else {
      setIsEdit(false);
      setDefaultDate(null);
    }
  }, [location.pathname]);

  const roleSectionClasses = teacherRole.section
    ? classes.filter((cls) => cls.section === teacherRole.section)
    : classes;

  const roleClassOptions = roleSectionClasses?.map((i: any) => ({
    label: i.class_name,
    value: i.class_name,
  }));

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          {/* {JSON.stringify({teacherClass})} */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="mb-1">{isEdit ? "Edit" : "Add"} Teacher</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherList}>Teacher</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {isEdit ? "Edit" : "Add"} Teacher
                  </li>
                </ol>
              </nav> */}
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <form>
                <>
                {/* {JSON.stringify(teacherRoles, null,)} */}
                  {/* Personal Information */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-info-square-rounded fs-16" />
                        </span>
                        <h4 className="text-dark">Personal Information</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              <i className="ti ti-photo-plus fs-16" />
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-3">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    multiple
                                  />
                                </div>
                                <Link to="#" className="btn btn-primary mb-3">
                                  Remove
                                </Link>
                              </div>
                              <p className="fs-12">
                                Upload image size 4MB, Format JPG, PNG, SVG
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {JSON.stringify(form)} */}

                      <div className="row row-cols-xxl-5 row-cols-md-6">
                        {/* <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Teacher ID</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "T849126" : undefined}
                            />
                          </div>
                        </div> */}

                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Full Name</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "Teresa" : undefined}
                              name="name"
                              value={form.name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        {/* <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Last Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="last_name"
                              value={form.last_name}
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Sex</label>
                            <CommonSelect
                              // handleChange={handleChange}
                              className="select"
                              options={allSex}
                              defaultValue={{
                                label: form.sex,
                                value: form.sex,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  sex: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Age</label>
                            <input
                              type="number"
                              className="form-control"
                              name="age"
                              value={form.age}
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}

                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Address:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="address"
                              value={form.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Date of Birth</label>
                            <div className="input-icon position-relative">
                              {isEdit ? (
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  value={defaultDate}
                                  placeholder="Select Date"
                                />
                              ) : (
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  defaultValue=""
                                  placeholder="Select Date"
                                  // name="date_of_birth"
                                  // value={form.date_of_birth}
                                  // onChange={handleChange}
                                />
                              )}

                              <span className="input-icon-addon">
                                <i className="ti ti-calendar" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Marital Status</label>
                            <CommonSelect
                              className="select"
                              options={MaritalStatus}
                              defaultValue={{
                                label: form.marital_status,
                                value: form.marital_status,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  marital_status: newValue
                                    ? newValue.value
                                    : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              State of Origin:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "Francis Saviour" : undefined
                              }
                              name="state_of_origin"
                              value={form.state_of_origin}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mobile No:</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "Stella Bruce" : undefined}
                              name="mobile_number"
                              value={form.mobile_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email Address:</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "Stella Bruce" : undefined}
                              name="email_address"
                              value={form.email_address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Qualification</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "MBA" : undefined}
                              name="qualification"
                              value={form.qualification}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Work Experience
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "2  Years" : undefined}
                              name="working_experience"
                              value={form.working_experience}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Religion</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "Oxford Matriculation, USA" : undefined
                              }
                              name="religion"
                              value={form.religion}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Last Place of Work:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit
                                  ? "1852 Barnes Avenue, Cincinnati, OH 45202"
                                  : undefined
                              }
                              name="last_place_of_work"
                              value={form.last_place_of_work}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Do you have any health-related problem?:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "+1 35676 45556" : undefined
                              }
                              name="do_you_have"
                              value={form.do_you_have}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Password
                            </label>
                            <div className="pass-group">
                            <input
                              type={isPasswordVisible ? "text" : "password"}
                              className="pass-input form-control"
                              name="password"
                              value={form.password}
                              onChange={handleChange}
                            />
                            <span
                              className={`ti toggle-password ${
                                isPasswordVisible ? "ti-eye" : "ti-eye-off"
                              }`}
                              onClick={togglePasswordVisibility}
                            />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-file fs-16" />
                        </span>
                        <h4 className="text-dark">Account Details</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Account Name:</label>
                            <input
                              // type="password"
                              className="form-control"
                              type="text"
                              name="account_name"
                              value={form.account_name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Account Number:
                            </label>
                            <input
                              // type="password"
                              className="form-control"
                              type="number"
                              name="account_number"
                              value={form.account_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Bank:</label>
                            <input
                              // type="password"
                              className="form-control"
                              type="text"
                              name="bank"
                              value={form.bank}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-file fs-16" />
                        </span>
                        <h4 className="text-dark">Class And Subject</h4>
                      </div>
                    </div>

                    {/* {JSON.stringify({ teacherClass })} */}
                    <div className="card-body pb-1">
                      <div className="row">
                        <table className="table datanew">
                          <thead className="thead-light">
                            <tr>
                              <th>Section</th>
                              <th>Class</th>
                              <th>Subject</th>
                              <th className="text-center"> + </th>
                            </tr>
                          </thead>
                          <tbody>
                            {teacherClasses.length
                              ? teacherClasses.map((x, idx) => (
                                  <tr key={idx}>
                                    <td>{x.section}</td>
                                    <td>{x.class_name}</td>
                                    <td>{x.subject}</td>
                                  </tr>
                                ))
                              : null}
                            <tr>
                              <td>
                                {/* <label className="form-label">Section</label> */}
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      className="select"
                                      options={mapped_section}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherClass((prev) => ({
                                          ...prev,
                                          section: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherClass.section,
                                        value: teacherClass.section,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      className="select"
                                      options={classOptions}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherClass((prev) => ({
                                          ...prev,
                                          class_name: newValue
                                            ? newValue.value
                                            : "",
                                          class_code: classOptions.find(
                                            (option:any) => option.value === newValue?.value
                                          )?.class_code || "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherClass.class_name,
                                        value: teacherClass.class_name,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                {/* {JSON.stringify(teacherClass.class_code)} */}
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherClass((prev) => ({
                                          ...prev,
                                          subject: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherClass.subject,
                                        value: teacherClass.subject,
                                      }}
                                      options={subjectOptions}
                                    />
                                  </div>
                                </div>
                              </td>

                              <td className="text-center">
                                {" "}
                                {teacherClass.class_name &&
                                teacherClass.subject ? (
                                  <Button
                                    type="primary"
                                    onClick={handleAdd}
                                    style={{ marginTop: 2 }}
                                    className="btn btn-primary outline"
                                  >
                                    Add +
                                  </Button>
                                ) : null}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-file fs-16" />
                        </span>
                        <h4 className="text-dark">Teacher Roles</h4>
                      </div>
                    </div>

                    <div className="card-body pb-1">
                      <div className="row">
                        <table className="table datanew">
                          <thead className="thead-light">
                            <tr>
                              <th>Section</th>
                              <th>Class</th>
                              <th>Role</th>
                              <th className="text-center"> + </th>
                            </tr>
                          </thead>
                          <tbody>
                            {teacherRoles.length
                              ? teacherRoles.map((x, idx) => (
                                  <tr key={idx}>
                                    <td>{x.section}</td>
                                    <td>{x.class_name}</td>
                                    <td>{x.role}</td>
                                  </tr>
                                ))
                              : null}
                            <tr>
                              <td>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      className="select"
                                      options={mapped_section}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherRole((prev) => ({
                                          ...prev,
                                          section: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherRole.section,
                                        value: teacherRole.section,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      className="select"
                                      options={roleClassOptions}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherRole((prev) => ({
                                          ...prev,
                                          class_name: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherRole.class_name,
                                        value: teacherRole.class_name,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <CommonSelect
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setTeacherRole((prev) => ({
                                          ...prev,
                                          role: newValue ? newValue.value : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: teacherRole.role,
                                        value: teacherRole.role,
                                      }}
                                      options={roleOptions}
                                    />
                                  </div>
                                </div>
                              </td>

                              <td className="text-center">
                                {teacherRole.class_name && teacherRole.role ? (
                                  <Button
                                    type="primary"
                                    onClick={handleAddRole}
                                    style={{ marginTop: 2 }}
                                  >
                                    Add +
                                  </Button>
                                ) : null}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* /Password */}
                </>

                <div className="text-end">
                  <button type="button" className="btn btn-light me-3">
                    Cancel
                  </button>
                  <Link
                    to="#"
                    className="btn btn-primary me-3"
                    //  to={routes.teacherList}
                    onClick={() => handleSubmit()}
                  >
                    Add New Teacher
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default TeacherForm;
